import React, { useEffect, useState } from "react";
import ContactUs from "../heroPoster/ContactUs";

interface ContactModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  subtitle?: string;
}

const ContactModal: React.FC<ContactModalProps> = ({ isOpen, onClose,title,subtitle }) => {
  const [formSubmitted , setFormSubmitted] = useState(false);

  useEffect(() => {
    if (formSubmitted) {
        onClose();
    }
  }, [formSubmitted, onClose]);


  return (
    <div
      className={`fixed inset-0 z-[1251] flex items-center justify-center transition-all duration-300 ${
        isOpen
          ? "pointer-events-auto opacity-100"
          : "pointer-events-none opacity-0"
      }`}
    >
      {/* Modal backdrop */}
      <div
        className="absolute inset-0 bg-gray-900 bg-opacity-50"
        onClick={onClose}
      ></div>

      {/* Modal content */}
      <div
        className={`relative max-h-[90vh] w-[95%] max-w-4xl transform overflow-auto rounded-lg bg-white p-1 shadow-xl transition-all duration-300 md:p-6 ${
          isOpen ? "scale-100" : "scale-95"
        }`}
          
      >
        {/* Close button */}
        <button
          type="button"
          onClick={onClose}
          className="absolute right-4 top-4 rounded-lg bg-transparent p-1.5 text-sm text-gray-700 hover:bg-gray-200"
        >
          <svg
            aria-hidden="true"
            className="h-5 w-5"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            ></path>
          </svg>
          <span className="sr-only">Close modal</span>
        </button>

        {/* Contact form */}

        <ContactUs
          title={title ?? ""} // Ensures string type
          titleGreen={subtitle ?? ""} // Ensures string type
          ModelclassName="relative mt-[30px] py-[60px] px-[5px] md:px-[30px] md:py-[10px]"
          isModal={true}
          setformSubmitted={setFormSubmitted}
        />
      </div>
    </div>
  );
};

export default ContactModal;
